import { CollectionView } from 'backbone.marionette';
import EmptyPlayerPoolView from "../../Fantasy/Team/Player/Empty";
import MatchCentrePlayer from "../MatchCentrePlayer";
import { Players } from '../../../collections';
import './index.styl';
import _ from 'lodash';
import Radio from "backbone.radio";
import { isMobile } from "../../../../../core/utils";

const MATCH_CENTRE_CHANNEL = Radio.channel('match_centre');


export class MatchCentrePlayersPool extends CollectionView {
	get childView() {
		return MatchCentrePlayer;
	}

	get emptyView() {
		return EmptyPlayerPoolView;
	}

	childViewOptions(model) {
		model.set({
			headings: this.headings,
			order_by: this.order_by,
			mobile_column: this.mobile_column,
			is_mobile: isMobile()
		});
	}
	childViewTriggers() {
		return {
			'player:show:popup': 'player:show:popup',
		}
	}

	viewComparator(a_model, b_model) {
		const order = this.is_asc_order ? 1 : -1;

		let is_bigger, is_less;

		switch (this.order_by) {
			case 'name':
				const
					a_name = a_model.getFullName(),
					b_name = b_model.getFullName();

				is_bigger = a_name < b_name;
				is_less = a_name > b_name;

				break;
			default:
				let
					a_result = _.result(a_model.attributes, this.order_by),
					b_result = _.result(b_model.attributes, this.order_by);

				const minimal =  99999 * order;

				a_result = this.isToSkip(a_result) ? minimal : a_result;
				b_result = this.isToSkip(b_result) ? minimal : b_result;

				is_bigger = a_result > b_result;
				is_less = a_result < b_result;

				break;
		}

		if (is_bigger) {
			return order;
		}

		if (is_less) {
			return -1 * order;
		}

		return 0;
	}

	isToSkip(value) {
		return _.isUndefined(value) || _.isString(value);
	}

	initialize() {
		this.collection = new Players();
		this.active_sorting = false;
		this.order_by = 'stats.points_last_round';
		this.is_asc_order = false;
		this.is_actual_round = false;

		this.headings = [];
		this.selected_match = {};

		this.listenTo(MATCH_CENTRE_CHANNEL, 'sorting', this.sortCollection)
	}

	init({ players, headings, selected_match, is_actual_round }) {
		this.headings = headings;
		this.selected_match = selected_match;
		this.is_actual_round = is_actual_round;

		this.collection.reset(players.filter(_.bind(this.getFilteredPlayers, this)));
		this.is_playing_exist = this.collection.find(player => player.isShouldPlay());

		if (selected_match.status === 'scheduled' && !this.active_sorting) {
			this.order_by = 'stats.avg_points';
		}
		else {
			this.order_by = 'stats.points_last_round';
		}
		this.mobile_column = this.order_by;

		this.setFilter(
			this.filterCollection,
			{ preventRender: true }
		);

		this.collection.trigger('reset');
	}

	getFilteredPlayers(child) {
		const { home_squad_id, away_squad_id } = this.selected_match;

		return [home_squad_id, away_squad_id].includes(child.get('squad_id'))
	}

	filterCollection(child) {
		const pts = _.result(child.attributes, 'stats.points_last_round'),
			is_player_scored = parseInt(pts, 10)
		;

		let is_scored = true,
			is_status = true
		;

		if (pts === 'DNP') {
			is_scored = false;
		}

		if (this.is_actual_round) {
			const by_status = this.is_playing_exist ? child.isShouldPlay() : child.isAvailable();
			is_status = is_player_scored || (by_status && is_scored);
		}

		return ![is_scored, is_status].includes(false);
	}

	sortCollection({ order_by, is_asc_order }) {
		this.order_by = order_by;
		this.is_asc_order = is_asc_order;
		this.active_sorting = true;

		this.collection.trigger('reset');
	}
}

export default MatchCentrePlayersPool;